import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import TextControl from '../components/customizedInputs/TextControl';
import usuariosServices from '../services/usuariosServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';

const ActivarUsuario = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false);
  const [tieneToken, setTieneToken] = useState(false);

  let { token } = useParams();

  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    } else {
      setRenderHTML(true)

      if(token){
        setTieneToken(true)
        activarUsuario(token)
      } else {
        setTieneToken(false)
      }
    }

  }, [authInformation, token]);


  const activarUsuario = async (token) => {
    try {
      const data = await usuariosServices.activarUsuario({token: token});

      alert(data.message)
      navigate(`/ingreso`);
    } catch (error) {
      errorMessage(error)
    }
  };


  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <div className="card mb-3">
                <div className="card-body">
                  {
                    tieneToken ? (
                      <>
                        <h5 className="card-title">Activando ...</h5>
                      </>
                    ) : (
                      <>
                        <h5 className="card-title">Error en la activación</h5>
                      </>
                    )
                  }

                </div>
              </div>
            </form>
          </main>
        )
      }

    </>
  );
};

export default ActivarUsuario;